import { useSearchParams } from 'react-router-dom';

/**
 * The active tab lives in `?tab=`, so a tab can be linked, bookmarked and
 * restored with Back. Same mechanism as SmsScreen. An unknown or missing
 * value falls back to `fallback`.
 */
export function useTabParam<T extends string>(allowed: readonly T[], fallback: T): [T, (id: T) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const asked = searchParams.get('tab');
  const active = (allowed as readonly string[]).includes(asked ?? '') ? (asked as T) : fallback;
  const setActive = (id: T) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', id);
    setSearchParams(next, { replace: true });
  };
  return [active, setActive];
}
